import { CountUp } from 'countup.js';
import Alpine from 'alpinejs';

export default function initCounterAndChartCard() {
  Alpine.data('counterAndChartCard', () => ({
    init() {
      // @ts-ignore
      const donut = this.$el.querySelector('.donut-chart');

      if (donut) {
        const observeDonut = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
              // @ts-ignore
              const { animated } = entry.target.dataset;
              if (!animated) {
                entry.target.classList.add('donut-animate');
                // @ts-ignore
                // eslint-disable-next-line no-param-reassign
                entry.target.dataset.animated = 'true';
                obs.unobserve(entry.target);
              }
            }
          });
        }, {
          threshold: 0.7,
        });

        observeDonut.observe(donut);

        this.loadCountersCards();
      }
    },
    instanceCountUp(item: HTMLElement) {
      const { prefix, suffix, number } = item.dataset;
      const options = {
        prefix,
        suffix,
        duration: 4,
        useEasing: true,
      };
      const getValue = Number(number);
      if (getValue > 0) {
        const countUpInstance = new CountUp(item, getValue, options);
        countUpInstance.start();
      }
    },
    loadCountersCards() {
      const counterCardsContent = this.$el;

      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            const mixedCardsItem = entry.target.querySelector('.donutchart__counter');
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7 && mixedCardsItem) {
              this.instanceCountUp(mixedCardsItem as HTMLElement);
              observerInstance.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.7,
        },
      );
      observer.observe(counterCardsContent);
    },
  }));
}
